<template>
    <div class="window-wrapper window-video-length-error">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">Недопустимая длительность видео. Пожалуйста, выберите видео длительностью до 10 мин.</div>
                    <div class="button-block">
                        <button @click="closeWindow" class="button button-dark button-close-window">ОК</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "VideoLengthErrorWindow",
    methods: {
        closeWindow() {
            $('.window-wrapper').removeClass('window-open');
            $('body').removeClass('blocked');
        }
    }
}
</script>

<style scoped>

</style>